import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getToken } from "./authToken";

export const samApi = createApi({
  reducerPath: 'samApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: process.env.REACT_APP_API_URL,
    headers: new Headers({Authorization:"Bearer " + getToken()}),
    prepareHeaders: async (headers) => {
      const tokenObj = getToken();
      if (tokenObj) {
        headers.set('Authorization', `Bearer ${getToken()}`);
        return headers;
      }
      // Throwing error causes promise to reject. Thus api call is not made.
      throw new Error('Auth header not ready.');
    },
  }),
  endpoints: (builder) => ({
    getAllUsers: builder.query<any, string>({
      query: () => `/users`,
    }),
    getUser: builder.query<any, string>({
      query: (userId) => `user/${userId}`,
    }),
    getApplications: builder.query<any, string>({
      query: () => `applications`,
    }),
    getApplicationsdetails: builder.query<any, string>({
      query: (AppId) => `applications/${AppId}`,
    }),
    getApplicationsExpiring: builder.query<any, string>({
      query: () => `/applications/expiring`,
    }),
    getMostExpensiveApplications: builder.query<any, string>({
      query: () => `/applications/most-expensive-usd`,
    }),
    getNearLimitApplications: builder.query<any, string>({
      query: () => `/applications/nearing-limit`,
    }),
    getOverusageApplications: builder.query<any, string>({
      query: () => `/applications/overusage-applications`,
    }),
    getEarliestEndDates: builder.query<any, string>({
      query: () => `/applications/earliest-end-dates`,
    }),
    getApplicationsUserCount: builder.query<any, void>({
      query: () => `/applications/user-count`,
    }),
    
    getUsersByLicense: builder.query<any, string>({ // New endpoint
      query: (AppId) => `/applications/${AppId}/users`,
    }),
    getVendors: builder.query<any, void>({
      query: () => `vendors`,
    }),
    getVendorsDetails: builder.query<any, string>({
      query: (VendorId) => `vendors/${VendorId}`,
    }),
    getPublishers: builder.query<any, void>({
      query: () => `publishers`,
    }),
    getPublishersDetails: builder.query<any, string>({
      query: (PublishersId) => `publishers/${PublishersId}`,
    }),
    getDevices: builder.query<any, void>({
      query: () => `devices`,
    }),
    getDevicesDetails: builder.query<any, string>({
      query: (DevicesId) => `devices/${DevicesId}`,
    }),
  }),
});

export const { 
  useGetAllUsersQuery, 
  useGetUserQuery, 
  useGetApplicationsQuery, 
  useGetApplicationsExpiringQuery, 
  useGetMostExpensiveApplicationsQuery, 
  useGetNearLimitApplicationsQuery,
  useGetOverusageApplicationsQuery,
  useGetEarliestEndDatesQuery, 
  useGetApplicationsUserCountQuery, 
  useGetUsersByLicenseQuery, // Export the new query
  useGetVendorsQuery, 
  useGetVendorsDetailsQuery, 
  useGetPublishersQuery,
  useGetPublishersDetailsQuery,
  useGetDevicesQuery,  
  useGetDevicesDetailsQuery, 
} = samApi;
